import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { SystemPopup } from '@gongxigames/framework/slot/types';
import { PromotionData } from '@gongxigames/framework/promotions/logic';
import { GameSessionPromotionEvents, GameSessionPromotionModule, GameSessionPromotionStates } from '@gongxigames/framework/promotions';

export class GameSessionPromotionStartState extends ModuleState<null, GameSessionPromotionModule, GameSessionPromotionEvents> {
    private startPopup?: SystemPopup;

    public onEnterState(): void {
        const promotion = this.module.getPromotion();

        this.startPopup = promotion.shouldShowContinuePopup?.() ? this.createContinuePopup() : this.createStartPopup();

        this.module.activateCounter();
        this.module.showPopup(this.startPopup);
    }

    private createStartPopup(): SystemPopup {
        return this.module.popups.createGameSessionPromotionStartPopup({
            ...this.promotionData,
            onClickActionButton: this.onClickActionButton.bind(this),
        });
    }

    private createContinuePopup(): SystemPopup {
        return this.module.popups.createGameSessionPromotionContinuePopup({
            ...this.promotionData,
            onClickActionButton: this.onClickActionButton.bind(this),
        });
    }

    private onClickActionButton(): void {
        this.module.gotoState(GameSessionPromotionStates.IN_PROGRESS);
    }

    public onLeaveState(): void {
        if (this.startPopup) {
            this.module.hidePopup(this.startPopup);
            this.startPopup = undefined;
        }

        this.emit('General.Slot.SPIN.ENABLE', GameSessionPromotionModule.NAME);
        this.emit('GameSessionPromotion.START_STATE_LEFT');

        if (this.module.getPromotion().isActive()) {
            this.emit('General.Promotion.Started');
        }
    }

    private get promotionData(): PromotionData {
        return this.module.getPromotion().getData();
    }

    protected setupEvents(): void {}
}
